import { nodeListForEach } from 'Utils/common'
import { generateUniqueID } from 'Utils/common'

function Contents($module) {
 	this.$module = $module
 	// Use ID if specified or generate a unique one
 	this.$moduleID = ($module.getAttribute('id')) ? $module.getAttribute('id') : generateUniqueID() 
 	// Get contents list of module
 	this.$contentsList = $module.querySelector('.sta-contents__list')
 	// Get heading if exists
 	this.$contentHeading = $module.querySelector('.sta-contents__heading')
 	this.$contentLabel = $module.getAttribute('aria-label')
}


// Initialize component
Contents.prototype.init = function () {
  // Check for module
  if (!this.$module) {
    return
  }
  // Set ID on module
  this.$module.setAttribute('id',this.$moduleID)
  // Set ID on contents list
  this.$contentsList.setAttribute('id',this.$moduleID+'-list')

  // Set up toggle button
  this.initControls()
}

// Initialise controls and set attributes
Contents.prototype.initControls = function () {
  // Create "Open all" button and set attributes
  this.$toggleButton = document.createElement('button')
  this.$toggleButton.setAttribute('type', 'button')
  this.$toggleButton.setAttribute('class', 'sta-button-outline sta-contents__toggle')
  this.$toggleButton.setAttribute('aria-expanded', 'false')
  this.$toggleButton.setAttribute('aria-controls', this.$moduleID+'-list')

  // Try and set the button label to the same as the heading or the aria-label if they exist
  if(this.$contentHeading) {
  	this.$buttonLabel = this.$contentHeading.innerHTML
  } else if (this.$contentLabel) {
  	this.$buttonLabel = this.$contentLabel
  } else {
  	this.$buttonLabel = 'Menu'
  }
  this.$toggleButton.innerHTML = '<span class=\"sta-sr-only\">Open </span>'+this.$buttonLabel

  // Insert button above list
  this.$module.insertBefore(this.$toggleButton, this.$module.firstChild)

  // Handle events for the controls
  this.$toggleButton.addEventListener('click', this.onOpenOrCloseToggle.bind(this))
}

// Open or close menu depending on state
Contents.prototype.onOpenOrCloseToggle = function () {
  const $toggleState = this.$toggleButton.getAttribute('aria-expanded')

  if($toggleState == 'false'){
  	this.$toggleButton.innerHTML = '<span class=\"sta-sr-only\">Close </span>'+this.$buttonLabel
  	this.$toggleButton.setAttribute('aria-expanded', 'true')
  	this.$contentsList.classList.add('visible')
  } else {
  	this.$toggleButton.innerHTML = '<span class=\"sta-sr-only\">Open </span>'+this.$buttonLabel
  	this.$toggleButton.setAttribute('aria-expanded', 'false')
  	this.$contentsList.classList.remove('visible')
  }
}

export default Contents